import { API } from "aws-amplify";
import { updateOrganization } from "~/graphql/mutations";
import * as APITypes from "~/API";
import { LoaderData } from "~/types";
import { EMPTY_ORGANIZATION } from "./getOrganizationDetail/getOrganizationDetail";

/**
 * Edit an organization's details
 * @param payload - The fields to update
 * @returns Success status and updated organization data
 */
export const editOrganization = async (
  payload: APITypes.UpdateOrganizationInput
): Promise<LoaderData<APITypes.Organization>> => {
  try {
    const response = (await API.graphql({
      query: updateOrganization,
      variables: {
        input: payload,
      },
    })) as { data?: APITypes.UpdateOrganizationMutation };

    return {
      success: true,
      data: response.data?.updateOrganization || EMPTY_ORGANIZATION,
    };
  } catch (error) {
    console.error("Error editing organization:", error);
    return {
      success: false,
      data: EMPTY_ORGANIZATION,
      error,
    };
  }
};
